import React, { useState } from "react"

import useOnclickOutside from "react-cool-onclickoutside"

import { ButtonElement } from "@front-shared/elements/button.element.tsx"
import { PrimaryText } from "@front-shared/elements/primaryText.element.tsx"

import type { IButtonDropdownOption } from "../types/objects.types.ts"

export const ButtonDropdownElement: React.FunctionComponent<
    IButtonDropdownElementProps
> = props => {
    const containerRef = useOnclickOutside(() => {
        setIsDropdownActive(false)
    })

    const [isDropdownActive, setIsDropdownActive] = useState<boolean>(false)

    const toggleDropdown = () => {
        setIsDropdownActive(current => !current)
    }

    const onOptionClick = (item: IButtonDropdownOption) => {
        setIsDropdownActive(false)
        item.onClick()
    }

    return (
        <div ref={containerRef} className={`relative ${props.className ?? ""}`}>
            <ButtonElement
                label={props.buttonLabel}
                onClick={toggleDropdown}
                htmlType="button"
                type={props.buttonType}
                icon={props.buttonIcon}
                isRightIcon={props.buttonIsRightIcon}
                isLoading={props.buttonIsLoading}
                disabled={props.buttonIsDisabled}
                buttonClassName={props.buttonClassName}
            />

            {isDropdownActive && (
                <div
                    className={`
                        absolute z-100 bg-brand-white right-0 top-[56px]
                        rounded-[8px] shadow-dropdown-menu border border-solid border-brand-warmLight
                        overflow-hidden
                        ${props.dropdownClassName ?? "w-[200px]"}
                    `}
                >
                    {props.options.map((item, index) => {
                        return (
                            <div
                                key={index}
                                role="button"
                                className={`
                                    p-[16px]
                                    ${item.isSelected ? "bg-brand-offWhite" : ""}
                                    ${item.isDisabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer hover:bg-brand-lilacLight"}
                                `}
                                onClick={
                                    !item.isDisabled
                                        ? () => {
                                              onOptionClick(item)
                                          }
                                        : undefined
                                }
                            >
                                <PrimaryText typography="buttonText">
                                    {item.label}
                                </PrimaryText>
                            </div>
                        )
                    })}
                </div>
            )}
        </div>
    )
}

interface IButtonDropdownElementProps {
    className?: string
    buttonLabel: string
    options: IButtonDropdownOption[]
    buttonType?: "default" | "primary" | "ghost" | "dashed" | "link" | "text"
    buttonIcon?: string | React.ReactNode
    buttonIsLoading?: boolean
    buttonIsDisabled?: boolean
    buttonIsRightIcon?: boolean
    buttonClassName?: string
    dropdownClassName?: string
}
